import { render, staticRenderFns } from "./Castle.vue?vue&type=template&id=43ce76b8&scoped=true"
import script from "./Castle.vue?vue&type=script&lang=js"
export * from "./Castle.vue?vue&type=script&lang=js"
import style0 from "./Castle.vue?vue&type=style&index=0&id=43ce76b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce76b8",
  null
  
)

export default component.exports